export const SendLogo = (api, file, custId) => {
    const formData = new FormData()
    formData.append("file", file)
    return api.post(`/api/v1/File/sendLogo?custId=${custId}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

export const GetLogo = async (api, custId) => {
    try {
        const response = await api.get(`/api/v1/File/getLogo?custId=${custId}`, {
            responseType: 'blob'
        })
        if (!response.data.type.startsWith("image/")) {
            console.error("Plik nie jest obrazem:", response.data.type)
            return null
        }
        return URL.createObjectURL(response.data)
    } catch (error) {
        console.error(error)
        return null
    }
}

export const SendOrderFiles = (api, files, orderNo, siteId) => {
    const formData = new FormData()
    for (const file of files) {
        formData.append("files", file)
    }

    return api.post(
        `/api/v1/File/sendOrderFiles?orderNo=${orderNo}&siteId=${siteId}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
}

export const DeleteLogo = (api, custId) => {
    return api.delete(`/api/v1/File/deleteLogo?custId=${custId}`)
}